<template>
  <div :class="['controls-box', 'm-1']">
    <div v-if="title" v-html="title" :class="['inline-block', 'controls-box-title']" />
    <div :ref="handle" :class="['p-1', 'controls-box-content']">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ControlsBox',
  props: {
    /**
     * Title of the control box
     */
    title: {
      type: String,
      required: false,
      default: null
    },
    handle: {
      type: String,
      required: false
    }
  }
}
</script>
<style>
.controls-box
{
  filter: drop-shadow(0 0 var(--em-1) var(--darkest));
}

.controls-box .controls-box-title
{
  border-radius: var(--border-radius) var(--border-radius) 0 0;
  font-size: .7em;
  width: auto;
  vertical-align: bottom;
  padding: .25em .5em;
  background: var(--dark);
}

.controls-box .controls-box-content
{
  font-size: .7em;
  border-radius: 0 var(--border-radius) var(--border-radius) var(--border-radius);
  background: var(--dark);
}
</style>



// WEBPACK FOOTER //
// src/components/controls-box.vue